import React from 'react';

const TempSol = () => {
  return <h1>TempSol Page</h1>;
};

export default TempSol;
